export const isValidFullName = (name: string) => {
    const nameTrimmed = name.trim();

    if (!nameTrimmed) return false;

    // These checks match those made in Cv2 to determine the validity of a name
    // https://gitlab.com/zoopla/perl-platform/codebase-v2/-/blob/master/lib/perl/Internal/Website/Constraints.pm
    const alphaSequence = '\\p{Alpha}\\p{M}';

    const fullNameComponent =
        `(?:[${alphaSequence}\\-'])*` +
        `[${alphaSequence}]{2,}` +
        `(?:[${alphaSequence}\\-'])*`;

    const shortNameComponent = `(?:[\\-.'${alphaSequence}])*`;

    const nameExpression =
        `(?:${shortNameComponent}\\s+)*` +
        `(?:${fullNameComponent}\\s+)+` +
        `(?:${shortNameComponent}\\s+)*` +
        fullNameComponent +
        `(?:,?\\s+${shortNameComponent})*`;

    return RegExp(`^${nameExpression}$`, 'u').test(nameTrimmed);
};
